import { roleModel } from '@ucr/role-model';

import { TPermissionKey, TRoleKey } from '../../types';

/** Хук для управления состоянием разрешений ролей */
export const usePermissions = (currentRoleKey?: TRoleKey) => {
  if (!currentRoleKey) {
    return {
      getCurrentRole: () => undefined,
      getCurrentRolePermissions: () => undefined,
      hasPermission: () => false,
    };
  }

  const getCurrentRole = () => {
    return roleModel.roles.find((role) => role.key === currentRoleKey);
  };

  const getCurrentRolePermissions = () => {
    return getCurrentRole()?.permissions;
  };

  const hasPermission = (permissionKey: TPermissionKey) => {
    return !!getCurrentRolePermissions()?.find((p) => p.key === permissionKey);
  };

  return {
    getCurrentRole,
    getCurrentRolePermissions,
    hasPermission,
  };
};
